import logoPV0Kooop from "./assets/PV0xKOOP.svg";  
import hybnost from "./assets/link_section/svg/hybnost.svg";
import sluch from "./assets/link_section/svg/sluch.svg";
import hendikep from "./assets/link_section/loga/hendikep.svg";
import urednici from "./assets/link_section/loga/uredniky_manazery.svg";  
import ridic from "./assets/link_section/images/ridic.png";
import urednik from "./assets/link_section/images/urednik.png"; 
import stopaB from "./assets/link_section/stopy/stopa-bottom.svg"; 
import stopaT from "./assets/link_section/stopy/stopa-top.svg";
import stopaBD from "./assets/link_section/stopy/stopa-bottom-dark.svg"; 

const HP = () => { 
  return (
    <>
      <main className="!m-0 overflow-x-hidden w-full min-h-[90vh] flex flex-col items-center gap-6 bg-[linear-gradient(27deg,_rgba(21,209,234,1)_20%,_rgba(0,121,193,1)_100%)]" id='start'>
        <section className="flex flex-col items-center py-14 gap-14 px-7 mobil:px-4 " id="projekt">
          <div className="flex flex-col items-center gap-4 text-white text-center">
            <h1 className="text-6xl">Kurzy</h1>
            <p className="max-w-[600px]">Platforma VIZE&nbsp;0&nbsp;zajišťuje kurzy pro řidiče s&nbsp;hendikepem a&nbsp;podílí se na školení pro úředníky a&nbsp;manažery veřejné správy. Díky nim přispíváme ke zvýšení bezpečnosti na silnicích. V rozcestníku níže se proklikněte na web s&nbsp;kurzy, které vás zajímají.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Box 1 – Řidiči s hendikepem */}
            <div className="relative overflow-hidden max-w-[450px] rounded-xl bg-gradient-to-b from-[#0073B7] to-[#212D69] stroke-[#6BB7E3] stroke-1 stroke-opacity-70 text-white pt-10 flex flex-col justify-between min-h-[500px]">
              <img
                src={stopaT}
                alt="Stopa dekorace"
                className="absolute top-0 left-0 w-1/2 pointer-events-none"
              />
              <img
                src={stopaB}
                alt="Stopa dekorace"
                className="absolute bottom-0 right-0 pointer-events-none w-1/2 z-10"
              />
              <div className="px-10">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <img src={hendikep} alt="Kurzy pro řidiče s hendikepem" className="w-[160px]" />
                  </div>
                  <div className="flex gap-2">
                    <img src={hybnost} alt="pro osoby s omezenou hybnosti" className="w-10 h-10" />
                    <img src={sluch} alt="pro sluchově postižené" className="w-10 h-10" />
                  </div>
                </div>
                <div className="flex flex-col gap-1" > 
                  <h4 className="text-xl font-bold">
                    Zlepšete své schopnosti za volantem
                  </h4>
                  <p className="text-sm font-light">
                    Vyzkoušejte si krizové situace v&nbsp;bezpečném prostředí. Kurzy vedené zkušenými lektory jsou přizpůsobeny řidičům s&nbsp;pohybovým i&nbsp;sluchovým hendikepem.
                  </p>
                </div>
              </div>

              <div>
                <img src={ridic} alt="Obrázek řidiče" className="min-h-xl w-full" /> 
              </div>
              <div className="absolute z-20 bottom-0 w-full p-10 mx-auto flex justify-center bg-gradient-to-t from-[#004E7E] to-transparent"> 
                <a
                  href="https://handy.vize0.cz"
                  className="button !w-full inline-flex items-center justify-between !bg-[#15D1EA] hover:!bg-[#00578B] text-blue-900 font-bold px-6 py-3 rounded-full transition duration-200 w-fit"
                >
                  Chci vědět víc 
                </a>
              </div>
            </div>

            {/* Box 2 – Úředníci */}
            <div className="relative overflow-hidden max-w-[450px] rounded-xl bg-gradient-to-b from-[#283676] to-[#1d1b5c] stroke-[#6BB7E3] stroke-1 stroke-opacity-70 text-white pt-10 flex flex-col justify-between min-h-[500px]">
              <img
                src={stopaT}
                alt="Stopa dekorace"
                className="absolute top-0 left-0 w-1/2 pointer-events-none"
              />
              <img
                src={stopaBD}
                alt="Stopa dekorace"
                className="absolute bottom-0 right-0 pointer-events-none w-[80%]"
              />
              
              <div className="px-10">
                <div className="flex justify-between items-start mb-6"> 
                  <div>
                    <img src={urednici} alt="Kurzy pro řidiče s hendikepem" className="w-[160px]" />
                  </div>
                </div>
                <div className="flex flex-col gap-1" > 
                  <h4 className="text-xl font-bold leading-snug">
                    Dopravní řešení v praxi
                  </h4>
                  <p className="text-sm font-light leading-relaxed">
                    Odborný program k&nbsp;povolování dopravních staveb a&nbsp;místní úpravě provozu. Pro odborný personál i&nbsp;vedoucí představitele krajů a&nbsp;obcí.
                  </p>
                </div> 
              </div>
              <div>
                <img src={urednik} alt="Obrázek úředníka" className="min-h-xl w-full" /> 
              </div>
              <div className="absolute bottom-0 w-full p-10 mx-auto flex justify-center bg-gradient-to-t from-[#1E2A62] to-transparent"> 
                <a
                  href="https://www.cendis.cz/dopravniresenivpraxi/"
                  className="button !w-full inline-flex items-center justify-between !bg-[#E79D19] hover:!bg-[#CB8815] text-blue-900 font-bold px-6 py-3 rounded-full transition duration-200 w-fit"
                >
                  Chci vědět víc 
                </a>
              </div>
            </div>
          </div> 
        </section> 
      </main>
      <footer className="bg-[#0079C1] text-white w-full flex flex-col items-center justify-center">
        <div className="w-[80%] max-w-[90vw] md:max-w-[80vw] lg:max-w-[70vw] flex flex-col md:flex-row justify-between items-center gap-8 py-12 text-center md:text-left">
          {/* Left Section */}
          <div className="w-full max-w-[400px] flex flex-row gap-10">
            <div className="flex items-center mb-4 flex-wrap gap-2 sm:gap-4 sm:flex-nowrap">
              <img src={logoPV0Kooop} alt="PV0 + KOOP logo" className="max-w-[40%] sm:max-w-none" /> 
            </div>
            <p className="font-light pt-4 text-sm">
              Platforma VIZE 0, z. ú. <br />
              Pobřežní 665/21, <br />
              Karlín 186 00 Praha 8
            </p>
          </div> 
        </div>

        {/* Copyright */}
        <div className="bg-black w-full py-2 px-[5%] text-center text-xs">
          Copyright © {new Date().getFullYear()} Platforma VIZE 0
        </div>
      </footer>
    </>
  );
};

export default HP;